import {
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  Input,
  OnDestroy,
  output,
} from '@angular/core';
import { SiaBaseScriptComponent, SiaSizeDetectorService } from '@sia/shared';
import { Guid } from 'guid-typescript';

@Component({
  selector: 'sia-base-editor',
  template: '',
  standalone: true,
})
export class SiaBaseEditorComponent
  extends SiaBaseScriptComponent
  implements OnDestroy
{
  protected cdr = inject(ChangeDetectorRef);
  protected siaSizeDetector = inject(SiaSizeDetectorService);

  infoIcon: string = '&#8505';
  //#endregion
  valueChanged = output<any>();
  //#endregion
  valueChange = output<any>();
  @Input() key: string | undefined | null;

  private _status?:
    | 'error'
    | 'warning'
    | 'info'
    | 'modified'
    | null
    | undefined;
  @Input() set status(
    value: 'error' | 'warning' | 'info' | 'modified' | null | undefined,
  ) {
    this._status = value;
    this.setInputClass();
  }

  private _modified: boolean = false;
  @Input() set modified(value: boolean) {
    this._modified = value;
    this.setInputClass();
  }

  protected get isModifiedFlag(): boolean {
    return this._modified || this._status === 'modified';
  }
  @Input() name?: string;

  private _showBottomMargin: boolean = false;
  get showBottomMargin(): boolean {
    return this._showBottomMargin;
  }
  @Input() set showBottomMargin(value: boolean) {
    this._showBottomMargin = value;
    this.cdr.detectChanges();
  }

  @Input() tabDisabled?: boolean;

  protected _id?: string | undefined = Guid.create().toString();
  get id(): string | undefined {
    return this._id;
  }
  @Input() set id(value: string | undefined) {
    this._id = value;
  }
  @Input() statusMessage?: string;
  @Input() statusMessages?: Map<string, string>;
  @Input() customClass: string | undefined = '';
  @Input() inputClass: string = '';

  #baseValueChangeTimeout: any;

  setInputClass() {
    var baseClass = 'sia-input sia-input';
    var inputFinalClass = '';

    if (this._status) {
      if (this._status == 'error') {
        inputFinalClass += baseClass + '--invalid ';
      } else {
        inputFinalClass += baseClass + '--' + this._status;
      }
    } else {
      if (this._modified) {
        inputFinalClass += baseClass + '--modified ';
      }
    }
    if (!this._label) {
      inputFinalClass += baseClass + '--no-label ';
    }
    this.inputClass = inputFinalClass;
  }
  @Input() set disabled(v) {
    if (v == undefined || v == null) return;
    this._isDisabled = typeof v === 'boolean' ? v : v === 'true';
    if (v) {
      this.class = 'sia-disabled';
    } else {
      this.class = 'sia-not-focus';
    }
    // this.cdr.detectChanges();
  }

  @Input() set value(v) {
    // if (
    //   v == this._value ||
    //   JSON.stringify(v) == JSON.stringify(this._value) ||
    //   (v == null && this._value == null) ||
    //   (v == undefined && this._value == undefined) ||
    //   (v?.length == 0 && this._value?.length == 0)
    // ) {
    //   return;
    // }
    this._value = v;
    if (this.#baseValueChangeTimeout) {
      clearTimeout(this.#baseValueChangeTimeout);
    }
    // Allow derived components to react immediately to internal value changes
    this.onInternalValueSet(v);
    this.#baseValueChangeTimeout = setTimeout(() => {
      this.valueChange.emit(v);
      this.valueChanged.emit(v);
    }, 300);
  }

  private _label?: string | undefined | null;
  get label(): string | undefined | null {
    return this._label;
  }
  @Input() set label(value: string | undefined | null) {
    this._label = value;
    this.setInputClass();
  }

  private _info?: string | undefined | null;
  get info(): string | undefined | null {
    return this._info;
  }
  @Input() set info(value: string | undefined | null) {
    this._info = value;
  }

  protected _value: any;
  get value() {
    return this._value;
  }
  protected _isDisabled: boolean = false;
  class: string = 'sia-not-focus';

  get disabled() {
    return this._isDisabled;
  }

  @HostListener('window:unload')
  ngOnDestroy() {
    this.statusMessages?.clear();
    this.statusMessages = undefined;
    this._value = null;
    this.key = '';
    this.label = '';
    if (this.#baseValueChangeTimeout) {
      clearTimeout(this.#baseValueChangeTimeout);
    }
    super.ngOnDestroy();
  }

  constructor() {
    super();
    this.setInputClass();
  }

  //#region public
  onValueChanged(value: any) {
    this.valueChanged.emit(value);
  }

  /**
   * Hook for derived classes to react to value assignment (immediately, before debounced outputs fire)
   * Override in subclasses when needed.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected onInternalValueSet(_newValue: any): void {}

  isFocused(e: any) {
    this.class = ' sia-focus';
  }
  isNotFocused(e: any) {
    this.class = ' sia-not-focus';
  }

  getFieldErrors(): string {
    if (this.statusMessages) {
      let errors = '';
      for (let value of this.statusMessages.values()) {
        errors += value + '\n';
      }
      return errors;
    }
    return this.statusMessage ?? '';
  }

  isVisibleTooltip() {
    return (this.statusMessages && this.statusMessages.size > 1) ?? false;
  }
  //#endregion
}
